import React from 'react';
import PropTypes from 'prop-types';
import analyticsWrapper from 'components_library/utils/analyticsWrapper';
import Link from 'components_library/atoms/Link/Link';
import classNames from 'classnames';
import s from './MoreButton.scss';

const MoreButton = props => {
  const {
    moreText,
    moreLink,
    doNotChangeURL,
    useLightBGMoreBtn,
    isNoLink,
    onClick,
    ga,
    typeShemaClassNames,
    isLoadLess,
    isFullWidth,
    isRedBg,
    isRedBrdr,
    wrapperClass,
    isUnderlineText,
    isNoArrow,
    isTextCapitalize,
  } = props;

  const buttonClass = classNames(typeShemaClassNames, {
    [s.lighBgBtn]: useLightBGMoreBtn,
    [s.isNoLink]: isNoLink,
    [s.loadLess]: isLoadLess,
    [s.redbg]: isRedBg,
    [s.redBrdr]: isRedBrdr,
    [s.fullWidth]: isFullWidth,
    [s.noArrow]: isNoArrow,
    [s.underlineText]: isUnderlineText,
    [s.textCapitalize]: isTextCapitalize,
  });
  if (!(moreLink || isNoLink)) return null;

  const onCtaClick = event => {
    if (typeof onClick === 'function') {
      onClick(event);
    }
    if (ga && ga.type) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: ga.type,
        category: 'more_stories_cta_click',
        label: moreText || 'Load More Stories',
      });
    }
  };

  return (
    <Link
      to={moreLink}
      target="_blank"
      className={`${buttonClass} ${s.morebtn} ${wrapperClass}`}
      doNotChangeURL={doNotChangeURL}
      isNoLink={isNoLink}
      onClick={onCtaClick}
    >
      {moreText || 'Load More Stories'}
    </Link>
  );
};

MoreButton.propTypes = {
  moreText: PropTypes.string,
  moreLink: PropTypes.string,
  doNotChangeURL: PropTypes.bool,
  useLightBGMoreBtn: PropTypes.bool,
  isNoLink: PropTypes.bool,
  onClick: PropTypes.func,
  ga: PropTypes.shape({}),
  isLoadLess: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  isRedBg: PropTypes.bool,
  isRedBrdr: PropTypes.bool,
  wrapperClass: PropTypes.string,
};
MoreButton.defaultProps = {
  moreText: '',
  moreLink: '',
  doNotChangeURL: false,
  useLightBGMoreBtn: false,
  isNoLink: false,
  onClick: null,
  ga: undefined,
  isLoadLess: false,
  isFullWidth: false,
  isRedBg: false,
  isRedBrdr: false,
  wrapperClass: '',
};

export default MoreButton;
